import React from "react";
import { Navigate } from "react-router";
import useQueryParams from "src/hooks/useQueryParams";
import { CHARGES_SUMMARY_ID_PARAMS } from "src/constants/chargesSummaryParams";

export default function DashboardRedirect() {
  const queryParams = useQueryParams();
  const chargesParams = CHARGES_SUMMARY_ID_PARAMS.filter(param => queryParams.get(param));

  if (chargesParams.length > 0) {
    const searchParams = new URLSearchParams();
    const copyParam = key => {
      const value = queryParams.get(key);
      if (value) searchParams.set(key, value);
    };

    chargesParams.forEach(copyParam);

    if (queryParams.get("assetChargesSummaryId")) {
      copyParam("assetReplayLogId");
      copyParam("startDate");
      copyParam("endDate");
    }

    return <Navigate to={`/shopping?${searchParams.toString()}`} replace />;
  }

  return <Navigate to="/403" replace />;
}
